export default {
  api_key: '5Tv5VWWBYtPNtkB2c4l3MPbePwtg1qtx',
  api_secret: '_NlDutPsgZ6HmG_y_bO4It6_Bj8IXlTA',
  image_base64: '',
  return_grayscale: 0,
}
